var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({ref:"country",attrs:{"value":_vm.value,"items":_vm.localCountries,"rules":_vm.rules,"label":"Country","item-text":"name","item-value":"code","data-cy":"country"},on:{"change":function($event){return _vm.$emit('input', $event)}}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }